<div class="accessManagement" role="main" *ngIf="outcome">
  <div class="content-container pt-3">
    <div>
      <h1 class="h-1 mt-0" tabindex="0">{{accessmanagementHeader}}</h1>
    </div>
    <div class="flex-display mt_1">
      <div class="width-100 mt-0-5rem">
        <input class="searchEmail"
               [(ngModel)]="filter" (ngModelChange)="onChangeText()" placeholder="Search Email"
               type="text">
      </div>
      <div>
        <button mat-button class="btn-primary-user-add" (click)="AddUser()" (keyup.enter)="AddUser()" tabindex="0">
          Add user
        </button>
      </div>
    </div>

    <table mat-table #genericTable="matSort" [dataSource]="dataSource" matSort (matSortChange)="customSort($event)" matSortActive="Email" matSortDirection="asc" aria-label="Users" class="mt-3rem" aria-describedby="access management table">
      <ng-container matColumnDef="FirstName">
        <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{firstNameCol}}</th>
        <td mat-cell *matCellDef="let element" [style.background-color]="sort?.active=='FirstName'?'#F0F5FF':null"> {{element.FirstName}} </td>
      </ng-container>

      <ng-container matColumnDef="LastName">
        <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{lastNameCol}}</th>
        <td mat-cell *matCellDef="let element" [style.background-color]="sort?.active=='LastName'?'#F0F5FF':null">
          {{element.LastName}}
        </td>
      </ng-container>

      <ng-container matColumnDef="Email">
        <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{emailCol}}</th>
        <td mat-cell *matCellDef="let element" [style.background-color]="sort?.active=='Email'?'#F0F5FF':null"> {{element.Email}} </td>
      </ng-container>

      <ng-container matColumnDef="Admin">
        <th scope="col" mat-header-cell *matHeaderCellDef>{{adminCol}}</th>
        <td mat-cell *matCellDef="let element">
          <input type="checkbox" disabled [(ngModel)]='element.Admin'>
        </td>
      </ng-container>

      <ng-container matColumnDef="Action">
        <th scope="col" mat-header-cell *matHeaderCellDef>{{actionCol}}</th>
        <td mat-cell *matCellDef="let element">
          <div class="flex-display accessBtn">
            <div>
              <button aria-label="edit" mat-icon-button (click)="editUser(element.Id)" title="Edit" (keyup.enter)="editUser(element.Id)" tabindex="0">
                <mat-icon class="edit-icon"></mat-icon>
              </button>
            </div>
            <div>
              <button aria-label="delete" mat-icon-button *ngIf="adminEmail != element.Email" (click)="redirectToDelete(element.Id)" (keyup.enter)="redirectToDelete(element.Id)" title="Remove" tabindex="0">
                <mat-icon class="delete-icon"></mat-icon>
              </button>
            </div>
          </div>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <div *ngIf="dataSource.data.length === 0" class="align-items-center text-align-norecords">{{noRecords}}</div>
    <div>
      <mat-paginator [pageSize]="pagesize" [pageSizeOptions]="pagelistarray" appHostListenerClick>
      </mat-paginator>
    </div>
  </div>
</div>
